const designActionOptions = [
	{
		id: 'friend_01',
		title: {
			da: 'Tegning',
			kl: 'Titartagaq',
		},
		description: {
			da: 'Jeres vens tegning',
			kl: 'Kammalaatissi titartagaa',
		},
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 10000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 2
			},
		]
	},
	{
		id: 'friend_02',
		title: {
			da: 'Tegning',
			kl: 'Titartagaq',
		},
		description: {
			da: 'Jeres vens anden tegning',
			kl: 'Kammalaatissi titartagaa',
		},
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 11000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 2
			},
		]
	},
	{
		id: 'graffiti_01',
		title: {
			da: 'Graffiti',
			kl: 'Graffiti',
		},
		description: {
			da: 'Den lokale graffiti-kunstners hurtige værk',
			kl: 'Najukkami graffitertartup sukkaannaq suliaa',
		},
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 11000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 2
			},
		]
	},
	{
		id: 'graffiti_02',
		title: {
			da: 'Graffiti',
			kl: 'Graffiti',
		},
		description: {
			da: 'Den lokale graffiti-kunstners fede værk',
			kl: 'Najukkami graffitertartup sukkaannaq suliaa',
		},
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 15000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 3
			},
		]
	},
	{
		id: 'indie_01',
		title: {
			da: 'Indieband-logo',
			kl: 'Indiemik nipilersortartut ilisarnaataat',
		},
		isLocked: true,
		description: {
			da: 'Kendt for "Jeg ved en lærkerede" på banjo og vaskebræt.',
			kl: '"Nuna asiilasoq" nutsugiamik atortarneranut tusaamaneqaateqartoq',
		},
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 14600,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 3
			},
		],
	},
	{
		id: 'indie_02',
		title: {
			da: 'Indieband-logo',
			kl: 'Indiemik nipilersortartut ilisarnaataat',
		},
		isLocked: true,
		description: {
			da: 'Band med 3 brødre med forskellige mødre.',
			kl: 'Nipilersortartut angutit qatanngutigiit pingasut assigiinngitsunik tamarmik anaanallit.',
		},
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 16000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 3
			},
		],
	},
	{
		id: 'indie_03',
		title: {
			da: 'Indieband-logo',
			kl: 'Indiemik nipilersortartut ilisarnaataat',
		},
		description: {
			da: 'Røg ud fra bootcamp i X-factor.',
			kl: 'Erinarsullaqqinneqqusaattuni ingerlaqqingaatsiarnikuulluni anisitaanikoq',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 15900,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 3
			},
		],
	},
	{
		id: 'indie_04',
		title: {
			da: 'Indieband-logo',
			kl: 'Indiemik nipilersortartut ilisarnaataat',
		},
		description: {
			da: 'Bandet Strawberry Man-Bun.',
			kl: 'Nipilersortartut Strawberry Man-Bun',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 16025,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 3
			},
		],
	},
	{
		id: 'psychedelic_01',
		title: {
			da: 'Psykedelisk mønster',
			kl: 'Takusuuserpalaartumik ilusilik',
		},
		isLocked: true,
		description: {
			da: '"Insidious wallflower" Psykedelisk mønster af en rising star på nettet.',
			kl: 'Insidious wallflower nittartakkatigut tusaamasanngoriartuinnartoq takusuuserpalaartumik ilusilik.',
		},
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 30000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 4
			},
		],
	},
	{
		id: 'psychedelic_02',
		title: {
			da: 'Psykedelisk mønster',
			kl: 'Takusuuserpalaartumik ilusilik',
		},
		isLocked: true,
		description: {
			da: '"Sans Titre" Psykedelisk mønster af en rising star på nettet.',
			kl: 'Sans Titre nittartakkatigut tusaamasanngoriartuinnartoq takusuuserpalaartumik ilusilik ',
		},
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 30000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 4
			},
		],
	},
	{
		id: 'psychedelic_03',
		title: {
			da: 'Psykedelisk mønster',
			kl: 'Takusuuserpalaartumik ilusilik',
		},
		description: {
			da: '"Le Kolour" Psykedelisk mønster af en rising star på nettet.',
			kl: 'Le Kolour nittartakkatigut tusaamasanngoriartuinnartoq takusuuserpalaartumik ilusilik.',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 32000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 4
			},
		],
	},
	{
		id: 'kawaii_01',
		title: {
			da: 'Kawaii',
			kl: 'Kawaii',
		},
		isLocked: true,
		description: {
			da: 'Kawaii art af jeres kontakt i Japan',
			kl: 'Japanimi attaveqaatissinniit Kawaii eqqumiitsuliat',
		},
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 33000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 4
			},
		],
	},
	{
		id: 'kawaii_02',
		title: {
			da: 'Kawaii',
			kl: 'Kawaii',
		},
		isLocked: true,
		description: {
			da: 'Kawaii art af jeres kontakt i Japan',
			kl: 'Japanimi attaveqaatissinniit Kawaii eqqumiitsuliat',
		},
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 30000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 4
			},
		],
	},
	{
		id: 'kawaii_03',
		title: {
			da: 'Kawaii',
			kl: 'Kawaii',
		},
		description: {
			da: 'Kawaii art af jeres kontakt i Japan',
			kl: 'Japanimi attaveqaatissinniit Kawaii eqqumiitsuliat',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 75000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 5
			},
		],
	},
	{
		id: 'kawaii_04',
		title: {
			da: 'Kawaii',
			kl: 'Kawaii',
		},
		description: {
			da: 'Kawaii art af jeres kontakt i Japan',
			kl: 'Japanimi attaveqaatissinniit Kawaii eqqumiitsuliat',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 80000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 5
			},
		],
	},
	{
		id: 'kawaii_05',
		title: {
			da: 'Kawaii',
			kl: 'Kawaii',
		},
		description: {
			da: 'Kawaii art af jeres kontakt i Japan',
			kl: 'Japanimi attaveqaatissinniit Kawaii eqqumiitsuliat',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 83000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 5
			},
		],
	},
	{
		id: 'streetart_01',
		title: {
			da: 'Street art',
			kl: 'Aqqusinermi eqqumiitsuliat',
		},
		description: {
			da: 'Betonkunst',
			kl: 'Betonimut eqqumiitsuliat',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 24500,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 3
			},
		],
	},
	{
		id: 'streetart_02',
		title: {
			da: 'Street art',
			kl: 'Aqqusinermi eqqumiitsuliat',
		},
		description: {
			da: 'Edgy artwork',
			kl: 'Allakajaanik eqqumiitsuliorneq',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 35000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 4
			},
		],
	},
	{
		id: 'streetart_03',
		title: {
			da: 'Street art',
			kl: 'Aqqusinermi eqqumiitsuliat',
		},
		description: {
			da: 'Det bliver ikke mere street',
			kl: 'Aqqusinermiorpalaarnerusinnaanngilaq',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 37000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 4
			},
		],
	},
	{
		id: 'horrorart_01',
		title: {
			da: 'Horror art',
			kl: 'Ersinartunik eqqumiitsuliorneq',
		},
		description: {
			da: 'Monster fedt artwork',
			kl: 'Eqqumiitsuliat torrassuaartut',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 29000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 3
			},
		],
	},
	{
		id: 'horrorart_02',
		title: {
			da: 'Horror art',
			kl: 'Ersinartunik eqqumiitsuliorneq',
		},
		description: {
			da: 'Kommende b-film logo',
			kl: 'B-filmip saqqummertussap ilisarnaataa',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 35000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 4
			},
		],
	},
	{
		id: 'horrorart_03',
		title: {
			da: 'Horror art',
			kl: 'Ersinartunik eqqumiitsuliorneq',
		},
		description: {
			da: 'MunsterFar\'s (alias for Tamarik Vin Skjold) debutværk.',
			kl: 'MunsterFar-ip (Tamarik Vin Skjoldip taagutaa) suliaminit siullermeerluni saqqummersitaa.',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 77000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 5
			},
		],
	},
	{
		id: 'metalband_01',
		title: {
			da: 'Metal band',
			kl: 'Metalimik nipilersortartut',
		},
		description: {
			da: 'Hypet lokalt metalband',
			kl: 'Najukkami metalimik nipilersortartut soqutigineqartorujussuit',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 36000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 4
			},
		],
	},
	{
		id: 'metalband_02',
		title: {
			da: 'Metal band',
			kl: 'Metalimik nipilersortartut',
		},
		description: {
			da: 'Spiller den mærkværdige genre CrabCore',
			kl: 'Nipilersoriaaseq allakajaaq CrabCore atussavaat',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 39000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 4
			},
		],
	},
	{
		id: 'metalband_03',
		title: {
			da: 'Metal band',
			kl: 'Metalimik nipilersortartut',
		},
		description: {
			da: 'Rising star death metal band',
			kl: 'Death metalimik nipilersortartuni tusaamasanngoriartortoq',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 40000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 4
			},
		],
	},
	{
		id: 'stjernekunst_01',
		title: {
			da: 'Stjernekunst',
			kl: 'Tusaamasat eqqumiitsuliaat',
		},
		description: {
			da: 'Et værk af den internationele kunststjerne Tamarik Vin Skjold',
			kl: 'Nunani tamalaani tusaamasarsuup Tamarik Vin Skjoldip suliaa',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 85000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 5
			},
		],
	},
	{
		id: 'gueststar_01',
		title: {
			da: 'Special guest star',
			kl: 'Tusaamasaq immikkut pulaartoq',
		},
		description: {
			da: 'Den anonyme kunstner "Glem Mit Alias"',
			kl: 'Eqqumiitsuliortoq atiminik isertuussisoq "Taaguutera Puigoruk"',
		},
		isLocked: true,
		effects: [
			{
				type: 'expense',
				expenseType: 'design-expenses',
				expenseTitle: {
					da: 'Nye designs',
					kl: 'Ilutsit nutaat',
				},
				price: 95000,
			},
			{
				type: 'change-stat',
				statId: 'design-score',
				statValue: 5
			},
		],
	}
];

export default designActionOptions;